export default "__VITE_ASSET__B3Th0l29__"